'use client';

import { __spreadArray } from '../../_virtual/_tslib.js';

function formErrorsControl(_a) {
    var fieldName = _a.fieldName, formValues = _a.formValues, errorMsg = _a.errorMsg, requestScrollToFirstErrorElement = _a.requestScrollToFirstErrorElement;
    var formErrors = formValues.errors;
    if (formErrors[fieldName] !== undefined && errorMsg === '') {
        delete formErrors[fieldName];
        return;
    }
    if (errorMsg !== '') {
        formErrors[fieldName] = errorMsg;
        if (requestScrollToFirstErrorElement) {
            formValues.errorFields = __spreadArray(__spreadArray([], formValues.errorFields, true), [fieldName], false);
            formValues.isScrollToFirstErrorElement = true;
        }
    }
}

export { formErrorsControl as default };
//# sourceMappingURL=formErrorsControl.js.map
